export interface wow extends Window {
    WebGLRenderingContext: any;
    WebGL2RenderingContext: any;
    __REDUX_DEVTOOLS_EXTENSION__: any;
    opera: any;
    MSStream: any;
}
const w = (window as wow);
export default w;


// WEBPACK FOOTER //
// ./src/store/window.tsx